import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { Header } from "./components/header";
import { useQualidadeitemProcessosRiscosListaViewModel } from "../../viewModels/qualidade_processos_riscos_itens_view_model";
import { useMemo } from "react";
import { ItemProcessoRiscosLista } from "../../../domain/models/processos_riscos_item_lista";
import { GenerateQualidadeItemProcessosRiscosColumns } from "./columns/qualidade_processos_riscos_item";
import { useNavigate } from "react-router";
import { BackButton } from "../../../../../common/components/back_button";

export const ProcessosRiscosItens = () => {
  const viewModel = useQualidadeitemProcessosRiscosListaViewModel();
  const navigate = useNavigate();

  const QualidadeItemProcessoRiscosListaColumns = useMemo(() => {
    return GenerateQualidadeItemProcessosRiscosColumns({
      onActionEditar: viewModel.handleCadastroItemProcessoRiscosOpenState,
      onActionDeletar: viewModel.handleDeleteItemProcessoRiscosModalOpenState,
    });
  }, [viewModel.handleCadastroItemProcessoRiscosOpenState, viewModel.handleDeleteItemProcessoRiscosModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[150px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => navigate(`/ProcessosRiscos_cadastroitens/${viewModel.id}`)}>
                  Novo
                </PrimaryButton>
              </div>
              <BackButton onClick={() => viewModel.handleVoltar()} />
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Processos e Riscos
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Processos e Riscos</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <Header
            onClearFilters={viewModel.handleClearFilters}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            tipoPesquisa={viewModel.filters.tipoPesquisa}
            funcionarios={viewModel.filters.funcionariosLista ?? []}
            handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
          />

          <StyledDataGrid
            tableName="ProcessoRiscosLista"
            disableColumnMenu={false}
            getRowId={(row: ItemProcessoRiscosLista) => row.IdItemProcesso}
            columns={QualidadeItemProcessoRiscosListaColumns}
            loading={viewModel.loading}
            rows={viewModel.itemProcessosRiscosLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.ItemProcessosRiscosDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteItemProcessoRiscosModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaItemProcessosRiscos} />
    </>
  )
}